export const DEFAULT_DOCKER_IMAGE = "permissionless-scripts:staging";

export const DEFAULT_NPX_PACKAGE = "@gearbox-protocol/deploy-v3@next";

export const DEFAULT_NPX_ARGS = [
  "deploy-v3",
  "testnet/faucet",
  "testnet",
  "--save-dir",
  "${SHARED_DIR}/deploy-state",
];

export const FLAG_SYNC_FEEDS = "sync-feeds";

export const FLAG_IGNORE_ERRORS = "ignore-errors";
